module.exports = __webpack_public_path__ + "static/media/search-icon.453f1955.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/search-icon.svg
// module id = 1032
// module chunks = 1